import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import NexonLight from './fonts/Nexon/NEXON Lv1 Gothic OTF Light.woff';
import UniSansHeavy from './fonts/Uni-Sans-Heavy.woff';
import PoppinsLight from './fonts/Poppins/Poppins-Light.woff';
import AristaPro from './fonts/Arista/Arista-Pro-Trial-SemiBold.ttf.woff';

export default createGlobalStyle`
    ${reset};
    @import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:100,300,400,500,700,900|Roboto:100,300,400,500,700,900&display=swap');
    @import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP:100,300,400,500,700,900|Noto+Sans+SC:100,300,400,500,700,900|Noto+Sans+TC:100,300,400,500,700,900&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Abhaya+Libre:wght@400;500;600;700;800&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Sen:wght@400;700;800&display=swap"');
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700&display=swap"');
    @font-face {
        font-family: 'NEXON Lv1 Gothic OTF Light';
        src: url(${NexonLight}) format('woff');
    }
    @font-face {
        font-family: 'Uni-Sans-Heavy';
        src: url(${UniSansHeavy}) format('woff');
    }
    @font-face {
        font-family: 'Poppins-Light';
        src: url(${PoppinsLight}) format('woff');
    }
    @font-face {
        font-family: 'Arista-Pro-Trial-SemiBold.ttf';
        src: url(${AristaPro}) format('woff');
    }
    @font-face {
        font-family: 'NEXON Lv1 Gothic OTF';
        src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@2.1/NEXON Lv1 Gothic OTF.woff') format('woff');
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: 'NEXON Lv1 Gothic OTF';
        src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@2.1/NEXON Lv1 Gothic OTF Bold.woff') format('woff');
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: 'NEXON Lv1 Gothic OTF';
        src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_20-04@2.1/NEXON Lv1 Gothic OTF Light.woff') format('woff');
        font-weight: 300;
        font-style: normal;
    }

    * {
        box-sizing:border-box;
        margin: 0;
        padding: 0;
    }

    body {
        font-family: 'Noto Sans KR', 'Noto Sans JP', 'Noto Sans SC', 'Noto Sans TC', sans-serif;
        word-break: keep-all;
        word-wrap: break-word;
    }
    h1 {
        font-family: 'Sen', 'NEXON Lv1 Gothic OTF', sans-serif;
        font-weight: 300;
    }
    h2 {
        font-family: 'Arista-Pro-Trial-SemiBold.ttf', sans-serif;
    }
    p {
        /* font-weight: 200; */
        font-family: 'NEXON Lv1 Gothic OTF', 'Poppins-Light';
    }
    input {
        font-weight: 200;
        font-family: 'NEXON Lv1 Gothic OTF', 'Poppins-Light';
    }
    textarea {
        font-weight: 200;
        font-family: 'NEXON Lv1 Gothic OTF', 'Poppins-Light';
    }

    a {
        text-decoration:none;
    }
    
    button {
        outline: none;
        border: none;
    }

    input:focus{
        outline:none;
    }
`;